import { PRES } from '../chrome';

export const focusVisibleSx = {
  '&:focus': { outline: 'none' },
  '&:focus-visible': {
    outline: 'none',
    boxShadow: `0 0 0 2px ${PRES.surface}, 0 0 0 4px ${PRES.focusRing}`,
  },
} as const;

export const reducedMotionSx = {
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
} as const;
